import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "nameInput", "saveBtn", "feedback"]
  static values = { source: { type: String, default: "url" } }

  connect() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  }

  toggle() {
    const visible = this.formTarget.style.display === "none"
    this.formTarget.style.display = visible ? "flex" : "none"
    if (visible) {
      this.nameInputTarget.focus()
    }
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.style.display = "none"
    }
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      this.toggle()
    }
  }

  async save() {
    const name = this.nameInputTarget.value.trim()
    if (!name) {
      this.nameInputTarget.focus()
      return
    }

    const ids = this.getGeographyIds()
    if (ids.length === 0) return

    this.saveBtnTarget.disabled = true
    this.saveBtnTarget.textContent = "Saving..."

    try {
      const response = await fetch("/my-markets", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({ name, geography_ids: ids })
      })

      if (response.ok) {
        this.formTarget.style.display = "none"
        this.nameInputTarget.value = ""
        if (this.hasFeedbackTarget) {
          this.feedbackTarget.textContent = "Saved!"
          this.feedbackTarget.style.display = "inline"
          setTimeout(() => { this.feedbackTarget.style.display = "none" }, 3000)
        }
      } else {
        const data = await response.json()
        alert(data.errors?.join(", ") || "Failed to save")
      }
    } catch (error) {
      console.error("Save error:", error)
    } finally {
      this.saveBtnTarget.disabled = false
      this.saveBtnTarget.textContent = "Save"
    }
  }

  getGeographyIds() {
    if (this.sourceValue === "checkboxes") {
      return Array.from(document.querySelectorAll('[data-market-finder-target="checkbox"]:checked'))
        .map(cb => cb.value)
    }
    return new URLSearchParams(window.location.search).getAll("geography_ids[]")
  }
}
